<template>
    <base-modal :visible="visible" title="Create new Flow" @close="$emit('close')">
        <base-backend-errors :data="create.error"/>
        <flow-form :loading="create.loading" @submit="submit" @cancel="$emit('close')"/>
    </base-modal>
</template>

<script>
import { mapState } from 'vuex';
import FlowForm from './FlowForm.vue';

export default {
    name: 'FlowCreateModal',
    components: { FlowForm },
    props: ['space', 'visible'],
    computed: mapState('flows', ['create']),
    methods: {
        submit(data) {
            this.$store.dispatch('flows/create', {
                space_id: this.space.id,
                data,
            }).then(() => {
                this.$store.dispatch('flows/list', { space_id: this.space.id });
                this.$emit('close');
            });
        },
    },
};
</script>
